import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useRest } from "@/composables/index";

const emptyForm = () => ({
  tipoDocumento: null,
  documento: "",
  gender: "",
  showDocument: "",
  cuil: "",
  apellido: "",
  nombre: "",
  edad: "",
  fechaNacimiento: "",
  nacionality: "",
  civilStatus: "",
  domicilio: "",
  telefono: "",
  email: "",
  profesion: "",
  haveStudies: "",
  instruction: "",
  observaciones: "",
  apodo: "",
  Identikit: [],
});

export const useVinculatedStore = defineStore("vinculated", () => {
  const selected = ref(null);
  const form = ref(emptyForm());
  const formType = ref("view"); // estados del formulario view, edit, create
  const vinculatedList = ref([]);
  const actuacionID = ref("");
  const rest = useRest();
  const isLoading = ref(false);
  const baseUrl = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-persona-fisica`;

  const fetchVinculateds = async (id, indexToRedirect) => {
    actuacionID.value = id;
    try {
      const url = `${baseUrl}/${id}/vinculados`;
      const resp = await rest.get(url);
      vinculatedList.value = resp.data.data;
      if (indexToRedirect !== undefined) {
        selectNextOrPrevious(indexToRedirect);
      } else {
        selectFirst();
      }
    } catch (e) {
      console.error("Error al traer Vinculados", e);
    }
  };

  const validateForm = () => {
    const camposObligatorios = ["TipoRolPersonaFisicaID"];

    if (!form.value) return false;

    let invalidField = camposObligatorios.find(
      (campo) => !form.value?.[campo] || form.value?.[campo] === ""
    );

    // Si se seleccionó un tipo de documento, el número de documento es obligatorio
    if (
      !invalidField &&
      form.value?.tipoDocumento &&
      form.value.tipoDocumento !== "" &&
      form.value?.apellido !== "Persona de Filiacion desconocida"
    ) {
      if (!form.value?.documento || form.value.documento === "") {
        invalidField = true;
      }
    }

    if (!invalidField) invalidField = form.value?.email !== "Error en el email" ? false : true;

    // Verificar si hay errores de validación en el formulario
    const hasValidationErrors = Object.values(validationErrors.value).some(
      (error) => error !== null && error !== "" && error !== undefined
    );

    isFormValid.value = !invalidField && !hasValidationErrors;
    return !invalidField && !hasValidationErrors;
  };

  const handlePutVinculateds = async () => {

    // Normalizar rol (por si viene string)
    //parche temporal hasta que se arregle en el componente
    //no deberia nunca venir como string
    //implementado por santy el 22/01/2026
    const rol = form.value?.TipoRolPersonaFisicaID;
    if (typeof rol === "string") {
      // console.log("Normalizando TipoRolPersonaFisicaID");
      const v = rol.trim();
      form.value.TipoRolPersonaFisicaID = v ? { id: v, nombre: v } : null;
    }
    if (!validateForm()) return;
    isLoading.value = true;

    const formatedVinculated = {
      ActuacionID: form.value?.actuacionID || actuacionID.value,
      ActuacionPersonaFisicaID:
        form.value?.ActuacionPersonaFisicaID !== undefined
          ? form.value?.ActuacionPersonaFisicaID
          : "",
      Apellido: form.value?.apellido,
      Apodo: form.value?.apodo === "Sin Registros" ? "" : form.value?.apodo,
      Celular: null,
      coelsa: [],
      Coelsa: [],
      CorreoElectronico: form.value.email || "",
      Cuil: form.value?.cuil,
      Cuit: form.value?.cuit,
      Denominacion: form.value?.denominacion,
      TipoDocumentoID: form.value.tipoDocumento?.id || "",
      NumeroIdentificacion: form.value?.documento,
      Dni: form.value?.documento,
      DomicilioJuridico: form.value?.domicilioJuridico,
      DomicilioSipe: form.value?.domicilio,
      Email: form.value.email || "",
      EstadoCivil: form.value?.civilStatus?.nombre,
      FechaDefuncion: null,
      FechaDeNacimiento: form.value?.fechaNacimiento,
      FechaDesde: "",
      FechaHasta: null,
      Instruccion: form.value?.instruction?.nombre,
      LugarDeNacimiento: null,
      Nacionalidad: form.value?.nacionality?.nombre,
      Nombre: form.value?.nombre,
      Orden: null,
      PersonaFisicaID: form.value?.PersonaFisicaID !== undefined ? form.value?.PersonaFisicaID : "",
      PersonaJuridica: false,
      Profesion: form.value?.profesion,
      Rubro: form.value?.rubro,
      Sexo: form.value?.gender?.nombre,
      Telefono: form.value?.telefono,
      TelefonoJuridico: form.value?.telefonoJuridico,
      TipoRolPersonaFisicaID: form.value?.TipoRolPersonaFisicaID?.nombre,
      Identikit: form.value?.Identikit,
      Observaciones: form.value?.observaciones,
      TieneSeguro: form.value?.tieneSeguro === true ? "1" : "0",
    };
    if (isEdit.value) {
      vinculatedList.value = vinculatedList.value.map((vinculated) => {
        if (vinculated?.PersonaFisicaID === form?.value?.PersonaFisicaID) {
          return {
            ...vinculated,
            ...formatedVinculated,
            CorreoElectronico:
              form.value.email || vinculated.Email || vinculated.CorreoElectronico || "",
            Email: form.value.email || vinculated.Email || vinculated.CorreoElectronico || "",
          };
        }
        return {
          ...vinculated,
          CorreoElectronico: vinculated.Email || vinculated.CorreoElectronico || "",
          Email: vinculated.Email || vinculated.CorreoElectronico || "",
        };
      });
    } else if (isCreate.value) {
      handleCreateVinculated(formatedVinculated);
    }
    await handleSave();
  };
  
  const handleSaveLocally = async () => {
    if (!validateForm()) return;
    isLoading.value = true;
  
    const formatedVinculated = {
      ActuacionPersonaFisicaID: form.value?.ActuacionPersonaFisicaID || `temp-${Date.now()}`,
      Apellido: form.value?.apellido || "Sin apellido",
      Apodo: form.value?.apodo === "Sin Registros" ? "" : form.value?.apodo,
      Celular: null,
      coelsa: [],
      Coelsa: [],
      CorreoElectronico: form.value.email || "",
      Cuil: form.value?.cuil,
      Cuit: form.value?.cuit,
      Denominacion: form.value?.denominacion,
      TipoDocumentoID: form.value.tipoDocumento?.id || "",
      NumeroIdentificacion: form.value?.documento,
      Dni: form.value?.documento,
      DomicilioJuridico: form.value?.domicilioJuridico,
      DomicilioSipe: form.value?.domicilio,
      Email: form.value.email || "",
      EstadoCivil: form.value?.civilStatus?.nombre,
      ExhibeDocumento: String(form.value.showDocument?.id),
      FechaDefuncion: null,
      FechaDeNacimiento: form.value?.fechaNacimiento,
      FechaDesde: "",
      FechaHasta: null,
      Instruccion: form.value?.instruction?.nombre,
      LugarDeNacimiento: null,
      Nacionalidad: form.value?.nacionality?.nombre,
      Nombre: form.value?.nombre,
      Orden: null,
      PersonaFisicaID: form.value?.PersonaFisicaID !== undefined ? form.value?.PersonaFisicaID : "",
      PersonaJuridica: false,
      Profesion: form.value?.profesion,
      Rubro: form.value?.rubro,
      Sexo: form.value?.gender?.nombre,
      Telefono: form.value?.telefono,
      TelefonoJuridico: form.value?.telefonoJuridico,
      TieneEstudios: String(form.value?.haveStudies?.id),
      TipoRolPersonaFisicaID: form.value?.TipoRolPersonaFisicaID?.nombre,
      Identikit: form.value?.Identikit,
      Observaciones: form.value?.observaciones,
      TieneSeguro: form.value?.tieneSeguro === true ? "1" : "0",
    };
  
    if (isCreate.value) {
      vinculatedList.value.push(formatedVinculated);
    } else if (isEdit.value) {
      const index = vinculatedList.value.findIndex(
        (v) => v.ActuacionPersonaFisicaID === form.value.ActuacionPersonaFisicaID
      );
      if (index !== -1) {
        vinculatedList.value[index] = formatedVinculated;
      }
    }
  
    isLoading.value = false;
    startView();
  };

  const handleDeleteVinculated = async (locally = false) => {
    isLoading.value = true;
    try {
      const selectedIndexArray = vinculatedList.value.findIndex(
        (item) => JSON.stringify(item) === JSON.stringify(selected.value)
      );
      vinculatedList.value = vinculatedList.value.filter(
        (vinculated) => vinculated.ActuacionPersonaFisicaID !== selectedId.value
      );
      if (!locally) await handleSave(selectedIndexArray);
    } catch (error) {
      console.error("Error al eliminar vinculado", error);
      isLoading.value = false;
      throw error;
    }
  };

  const handleCreateVinculated = (newVinculated) => {
    vinculatedList.value = [
      ...vinculatedList.value,
      {
        ...newVinculated,
      },
    ];
  };

  const handleSave = async (indexToRedirect) => {
    // siempre pega al mismo endpoint, solo se modifica el arreglo original
    try {
      const formattedVinculatedList = vinculatedList.value.map((vinculated) => ({
        ...vinculated,
        CorreoElectronico: vinculated.Email || vinculated.CorreoElectronico || "",
        Email: vinculated.Email || vinculated.CorreoElectronico || "",
      }));
      let options = {
        url: `${baseUrl}/${actuacionID.value}`,
        formData: { Vinculados: formattedVinculatedList },
        ContentType: "text/plain",
      };
      await rest.put(options);
      if (isCreate.value || isEdit.value) triggerSuccessModal();
    } catch (error) {
      throw error;
    } finally {
      isLoading.value = false;
      startView();
      if (indexToRedirect !== undefined) clear();
      fetchVinculateds(actuacionID.value, indexToRedirect);
    }
  };

  const select = (vinculated) => {
    selected.value = vinculated;
    hydrateFormFromDoc(vinculated);
    formType.value = "view";
  };

  const startCreate = () => {
    selected.value = null;
    form.value = emptyForm();
    formType.value = "create";
  };

  const hydrateFormFromDoc = (vinculated) => {
    form.value = {
      tipoDocumento: vinculated?.TipoDocumentoID || "",
      documento: vinculated?.NumeroIdentificacion || "",
      gender: { nombre: vinculated?.Sexo || "" },
      showDocument: vinculated?.ExhibeDoc || "",
      cuil: vinculated?.NroCuil || "",
      apellido: vinculated?.Apellido || "",
      nombre: vinculated?.Nombre || "",
      edad: vinculated?.Edad || "",
      fechaNacimiento: vinculated?.FechaNac || "",
      nacionality: { nombre: vinculated?.Nacionalidad || "" },
      civilStatus: { nombre: vinculated?.EstadoCivil || "" },
      domicilio: vinculated?.Domicilio || "",
      telefono: vinculated?.Telefono || "",
      email: vinculated?.Email || "",
      profesion: vinculated?.Profesion || "",
      haveStudies: vinculated?.TieneEstudios || "",
      instruction: { nombre: vinculated?.Instruccion || "" },
      observaciones: vinculated?.Observaciones || "Sin Registros",
      apodo: vinculated?.Apodo || "Sin Registros",
      TipoRolPersonaFisicaID:
        typeof vinculated?.TipoRolPersonaFisicaID === "string"
          ? {
              id: vinculated.TipoRolPersonaFisicaID,
              nombre: vinculated.TipoRolPersonaFisicaID,
            }
          : vinculated?.TipoRolPersonaFisicaID || null,
      PersonaFisicaID: vinculated?.PersonaFisicaID || null,
      ActuacionPersonaFisicaID: vinculated?.ActuacionPersonaFisicaID || "",
      Identikit: vinculated?.Identikit || [],
    };
  };

  const startEdit = () => {
    formType.value = "edit";
  };
  const startView = () => {
    formType.value = "view";
  };

  const resetForm = () => {
    form.value = emptyForm();
  };

  const clear = () => {
    selected.value = null;
    resetForm();
  };

  const selectFirst = () => {
    if (vinculatedList.value?.length) {
      select(vinculatedList.value[0]);
    }
  };

  const selectNextOrPrevious = (indexToRedirect) => {
    if (vinculatedList.value[indexToRedirect] === undefined) {
      select(vinculatedList.value[indexToRedirect - 1]);
      return;
    }
    if (vinculatedList.value?.length) {
      select(vinculatedList.value[indexToRedirect]);
    }
  };

  const selectedId = computed(() => selected?.value?.ActuacionPersonaFisicaID ?? null);

  const isSelected = (id) => selected.value?.ActuacionPersonaFisicaID === id;
  const isView = computed(() => formType.value === "view");
  const isEdit = computed(() => formType.value === "edit");
  const isCreate = computed(() => formType.value === "create");
  const inputsDisabled = computed(() => formType.value === "view");
  const isFormValid = ref(false);
  const validationErrors = ref({});

  const showSuccessModal = ref();

  const setShowSuccessModal = (fn) => {
    showSuccessModal.value = fn;
  };

  const triggerSuccessModal = () => {
    showSuccessModal.value?.();
  };

  const setValidationErrors = (errors) => {
    validationErrors.value = errors;
  };

  return {
    // state
    selected,
    form,
    formType,
    vinculatedList,
    isLoading,

    // actions
    select,
    hydrateFormFromDoc,
    resetForm,
    clear,
    startCreate,
    startEdit,
    handleSave,
    fetchVinculateds,
    handleCreateVinculated,
    handleDeleteVinculated,
    handlePutVinculateds,
    handleSaveLocally,
    startView,
    setShowSuccessModal,
    triggerSuccessModal,
    selectFirst,
    validateForm,
    selectNextOrPrevious,
    setValidationErrors,

    // getters
    selectedId,
    isSelected,
    isCreate,
    isEdit,
    isView,
    inputsDisabled,
    isFormValid,
  };
});
